export const heroSlides = [
  {
    id: 1,
    title: '午夜剧场 · 热门大片',
    subtitle: '深夜也有精彩相伴，高清画质秒播不等待',
    cta: '立即观看',
    link: '/category/movies',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinema%20theater%20at%20night%20with%20warm%20golden%20spotlights%20illuminating%20a%20stage%2C%20velvet%20curtains%20in%20deep%20crimson%2C%20atmospheric%20cinematic%20lighting%2C%20elegant%20movie%20theater%20interior%2C%20dramatic%20shadows%2C%20luxurious%20classic%20cinema%20aesthetic%2C%20dark%20ambient%20mood%2C%20high%20contrast&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
  },
  {
    id: 2,
    title: '熬夜追剧 · 畅爽体验',
    subtitle: '热播电视剧全集免费看，不缓冲不卡顿',
    cta: '开始追剧',
    link: '/category/tv-series',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20nighttime%20living%20room%20with%20large%20TV%20screen%20displaying%20cinematic%20content%2C%20warm%20amber%20ambient%20lighting%2C%20comfortable%20couch%20with%20blanket%2C%20city%20lights%20through%20window%2C%20relaxing%20night%20atmosphere%2C%20modern%20apartment%2C%20soft%20glow%2C%20immersive%20viewing%20experience&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
  },
  {
    id: 3,
    title: '夜猫子专属 · 海量片源',
    subtitle: '动作、喜剧、科幻、爱情，总有一部适合深夜的你',
    cta: '探索分类',
    link: '/category/movies',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20floating%20film%20strips%20and%20movie%20posters%20in%20dark%20space%2C%20golden%20and%20crimson%20light%20beams%20crossing%2C%20starry%20night%20sky%20background%2C%20dreamy%20movie%20themed%20art%2C%20elegant%20dark%20aesthetic%2C%20luxurious%20noir%20style%2C%20cinematic%20atmosphere&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
  },
];

export const categories = [
  { id: 'action', name: '动作片', icon: 'ri-sword-line', slug: 'movies', count: 1280, color: 'accent' },
  { id: 'comedy', name: '喜剧片', icon: 'ri-emotion-laugh-line', slug: 'movies', count: 960, color: 'primary' },
  { id: 'romance', name: '爱情片', icon: 'ri-heart-line', slug: 'movies', count: 750, color: 'accent' },
  { id: 'scifi', name: '科幻片', icon: 'ri-rocket-line', slug: 'movies', count: 640, color: 'secondary' },
  { id: 'horror', name: '恐怖片', icon: 'ri-ghost-line', slug: 'movies', count: 420, color: 'accent' },
  { id: 'animation', name: '动画片', icon: 'ri-palette-line', slug: 'anime', count: 890, color: 'primary' },
  { id: 'documentary', name: '纪录片', icon: 'ri-camera-line', slug: 'movies', count: 360, color: 'secondary' },
  { id: 'tvseries', name: '电视剧', icon: 'ri-tv-line', slug: 'tv-series', count: 1560, color: 'accent' },
];

export const featuredMovies = [
  {
    id: 1,
    title: '流浪地球3',
    category: '科幻片',
    rating: 9.2,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20dramatic%20lighting%2C%20dark%20color%20palette%20with%20golden%20accents%2C%20sci-fi%20film%20poster%20design%2C%20epic%20scale%2C%20professional%20movie%20poster%20composition&width=600&height=800&seq=featured-01&orientation=portrait',
    link: '/article/1',
  },
  {
    id: 2,
    title: '长安十二时辰',
    category: '电视剧',
    rating: 8.9,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20poster%20style%2C%20ancient%20Tang%20Dynasty%20cityscape%20at%20night%2C%20lanterns%20glowing%20warm%20amber%2C%20traditional%20architecture%2C%20dramatic%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%2C%20epic%20TV%20series%20poster&width=600&height=800&seq=featured-02&orientation=portrait',
    link: '/article/2',
  },
  {
    id: 3,
    title: '深海异兽',
    category: '动作片',
    rating: 8.7,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Underwater%20action%20movie%20poster%2C%20deep%20ocean%20with%20mysterious%20glowing%20creature%2C%20dark%20blue%20tones%2C%20dramatic%20light%20rays%20from%20above%2C%20thrilling%20cinematic%20atmosphere%2C%20professional%20film%20poster%20design&width=600&height=800&seq=featured-03&orientation=portrait',
    link: '/article/3',
  },
  {
    id: 4,
    title: '夏夜星辰',
    category: '爱情片',
    rating: 8.5,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20with%20couple%20silhouette%20under%20starry%20night%20sky%2C%20warm%20golden%20lighting%2C%20summer%20night%20atmosphere%2C%20soft%20cinematic%20bokeh%2C%20elegant%20romance%20film%20poster%20design%2C%20dreamy%20mood&width=600&height=800&seq=featured-04&orientation=portrait',
    link: '/article/4',
  },
  {
    id: 5,
    title: '鬼吹灯之昆仑神宫',
    category: '恐怖片',
    rating: 8.8,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Dark%20adventure%20horror%20movie%20poster%2C%20snowy%20mountain%20with%20ancient%20ruins%2C%20mysterious%20golden%20light%20from%20tomb%20entrance%2C%20atmospheric%20fog%2C%20cinematic%20thriller%20aesthetic%2C%20dark%20and%20dramatic%20color%20palette&width=600&height=800&seq=featured-05&orientation=portrait',
    link: '/article/5',
  },
  {
    id: 6,
    title: '大江大河3',
    category: '电视剧',
    rating: 9.0,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20drama%20poster%2C%20urban%20cityscape%20at%20dusk%2C%20river%20reflecting%20city%20lights%2C%20warm%20golden%20tones%2C%20professional%20TV%20series%20poster%20design%2C%20contemporary%20Chinese%20drama%20aesthetic&width=600&height=800&seq=featured-06&orientation=portrait',
    link: '/article/6',
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得熬夜追的十部国产剧，每一部都让人欲罢不能',
    excerpt: '从悬疑探案到古装权谋，今年这些国产剧凭实力成为爆款，夜猫子们的深夜追剧清单来了...',
    category: '剧评推荐',
    date: '2026-07-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20collection%20collage%2C%20various%20drama%20scenes%20arranged%20artistically%2C%20warm%20golden%20and%20dark%20tones%2C%20cinematic%20composition%2C%20entertainment%20blog%20feature%20image%2C%20professional%20design&width=800&height=450&seq=article-01&orientation=landscape',
    link: '/article/1',
  },
  {
    id: 2,
    title: '深夜影院观影指南：如何打造完美的家庭影院体验',
    excerpt: '一套舒适的家庭影院设备加上优质片源，让你在家也能享受IMAX级别的午夜观影体验...',
    category: '观影指南',
    date: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20and%20comfortable%20seating%2C%20dark%20room%20with%20ambient%20LED%20lighting%2C%20cozy%20atmosphere%2C%20premium%20audio%20equipment%2C%20cinematic%20viewing%20experience%2C%20warm%20dark%20tones&width=800&height=450&seq=article-02&orientation=landscape',
    link: '/article/2',
  },
  {
    id: 3,
    title: '动作片爱好者的狂欢：今夏最燃打斗场面大盘点',
    excerpt: '拳拳到肉的动作设计、肾上腺素飙升的追车戏码，这些动作大片让深夜观影充满激情...',
    category: '电影盘点',
    date: '2026-07-22',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20dynamic%20fight%20scene%20collage%2C%20explosive%20cinematic%20moments%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20dark%20shadows%2C%20thrilling%20movie%20montage%2C%20professional%20film%20blog%20header&width=800&height=450&seq=article-03&orientation=landscape',
    link: '/article/3',
  },
  {
    id: 4,
    title: '深夜追剧不伤眼：这些护眼小技巧每个夜猫子都该知道',
    excerpt: '长时间在黑暗环境中盯着屏幕，眼睛真的扛不住。收好这份护眼指南，安心做个快乐夜猫子...',
    category: '追剧技巧',
    date: '2026-07-20',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20night%20scene%20with%20warm%20desk%20lamp%20and%20computer%20screen%2C%20blue%20light%20filtering%20glasses%2C%20eye%20care%20concept%2C%20relaxing%20dark%20environment%2C%20soft%20warm%20lighting%2C%20healthy%20lifestyle%20blog%20image&width=800&height=450&seq=article-04&orientation=landscape',
    link: '/article/4',
  },
];

export const faqItems = [
  {
    question: '夜猫电影院需要付费吗？',
    answer: '完全免费！夜猫电影院所有电影、电视剧、动漫、综艺资源均可免费在线观看，无需任何会员费用。我们致力于为夜猫子们提供最优质的深夜观影体验。',
  },
  {
    question: '为什么选择深夜观影？平台有什么优势？',
    answer: '夜猫电影院针对夜间网络环境进行了专项优化，采用先进的CDN加速技术，确保深夜时段观影不缓冲、不卡顿。同时我们拥有海量高清片源库，涵盖动作、喜剧、科幻、爱情、恐怖、动画等多种类型。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '夜猫电影院支持全平台观看，无论是电脑、平板还是手机，都能获得流畅的高清观影体验。无需下载任何APP，打开浏览器即可开始追剧。',
  },
  {
    question: '影片更新频率如何？',
    answer: '我们保持每日更新，热播剧集同步上线，最新电影第一时间收录。每周新增超过200部影视作品，确保夜猫子们总有新片可看。',
  },
  {
    question: '观看时需要注册账号吗？',
    answer: '不需要！夜猫电影院无需注册即可直接观看所有内容，省去繁琐的注册流程，打开即看，让你更快进入观影状态。',
  },
  {
    question: '画质怎么样？支持高清吗？',
    answer: '所有影片均支持高清甚至超清画质，我们采用智能码率适配技术，根据您的网络环境自动调整最佳画质，兼顾清晰度和流畅度。',
  },
];

export const reputationData = [
  {
    name: '深夜追剧达人',
    role: '资深影迷',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%2C%20young%20Asian%20person%2C%20warm%20studio%20lighting%2C%20clean%20dark%20background%2C%20friendly%20expression%2C%20minimalist%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '作为一个资深夜猫子，夜猫电影院是我用过最流畅的深夜观影平台。片源丰富，更新快，最关键的是真的不卡顿！',
    rating: 5,
  },
  {
    name: '午夜电影控',
    role: '影视博主',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%2C%20young%20Asian%20female%2C%20warm%20studio%20lighting%2C%20clean%20dark%20background%2C%20confident%20expression%2C%20minimalist%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '做影视内容这么多年，夜猫电影院的片源质量和更新速度让我惊讶。高清画质，细腻的调色，深夜观影体验拉满。',
    rating: 5,
  },
  {
    name: '熬夜小王子',
    role: '大学生用户',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%2C%20young%20Asian%20male%20student%2C%20warm%20studio%20lighting%2C%20clean%20dark%20background%2C%20friendly%20smile%2C%20minimalist%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '宿舍深夜追剧就靠它了！不需要注册直接看，分类清晰找片快，而且各种类型都有，满足了我们宿舍不同口味的需求。',
    rating: 5,
  },
];